import * as React from 'react';
import { Book as BookType } from '../../../../../types/Book';
import { useField } from 'react-final-form';
import Book from '../../../../Book/Book';
import Button from '../../../../Button/Button';
import EditDetails from './EditDetails/EditDetails';

interface Props {
	index: number;
	book: BookType;
	updateValue: (index: number, value: any) => void;
	value: any;
	onDelete: () => void;
}

const BookItem: React.FC<Props> = props => {
	const [edit, setEdit] = React.useState(false);

	const field = useField(`books['${props.index}'].externalId`, {
		value: props.book.externalId
	});

	const nameField = useField(`books[${props.index}].bookName`);
	const descField = useField(`books[${props.index}].bookDesc`);

	const onSave = (name: string, desc: string) => {
		props.updateValue(
			props.index,
			{
				...props.value,
				bookName: name,
				bookDesc: desc
			}
		)
	}

	return <>
		<Book
			book={{
				...props.book,
				name: props.value.bookName
			}}
			type="row"
			disabled={true}
			payload={
				<>
					<div className="addCollection-books__desc">
						{props.value.bookDesc}
					</div>

					<div className="addCollection-books__buttons">
						<Button
							type="primary"
							onClick={() => props.onDelete()}
						>
							Удалить
						</Button>
						
						<Button
							type="primary"
							onClick={() => setEdit(true)}
						>
							Настроить отображение
						</Button>
					</div>
				</>
			}
		/>

		<input type="hidden" name={field.input.name} value={field.input.value} />

		<EditDetails
			open={edit}
			onClose={() => setEdit(false)}
			name={nameField.input.value}
			description={descField.input.value}
			onSave={onSave}
		/>
	</>;
};

export default BookItem;
